export default __webpack_public_path__ + "static/OpenSea-8645691bd43309d16a5677e39d67a8e3.png";